import { Component, type ErrorInfo, type ReactNode } from 'react';

import { Icone } from './Icone';

/**
 * Se algo quebra ao desenhar, mostra o aviso com "Recarregar" (como o
 * Discord) em vez de deixar a tela em branco.
 */
export class ProtecaoDeErro extends Component<
  { children: ReactNode },
  { erro: Error | null }
> {
  state = { erro: null as Error | null };

  static getDerivedStateFromError(erro: Error) {
    return { erro };
  }

  componentDidCatch(erro: Error, info: ErrorInfo) {
    console.error('Erro na interface do chat', erro, info.componentStack);
  }

  render() {
    if (!this.state.erro) return this.props.children;
    return (
      <div
        role="alert"
        className="flex h-full flex-col items-center justify-center gap-3 bg-rail p-8 text-center"
      >
        <span className="flex size-16 items-center justify-center rounded-[18px] bg-elevado text-ocupado">
          <Icone nome="alerta" tamanho={36} />
        </span>
        <h1 className="m-0 font-titulo text-2xl font-bold">Algo deu errado</h1>
        <p className="m-0 max-w-[420px] text-[15px] text-texto-2">
          A tela travou. Recarregue para continuar; o que estava escrito fica
          guardado.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-2 h-10 rounded-lg bg-destaque px-4 text-sm font-semibold text-destaque-texto"
        >
          Recarregar
        </button>
      </div>
    );
  }
}
